(function () {
  'use strict';

  function initPrestationsCarousel() {
    var track    = document.getElementById('lrn-prest-track');
    var prevBtn  = document.getElementById('lrn-prest-prev');
    var nextBtn  = document.getElementById('lrn-prest-next');
    var dotsWrap = document.getElementById('lrn-prest-dots');
    var curEl    = document.getElementById('lrn-prest-cur');
    var totEl    = document.getElementById('lrn-prest-tot');

    if (!track) return;

    var cards      = track.querySelectorAll('.lrn-prest-card');
    var totalCards = cards.length;
    var current    = 0;
    var visible    = getVisible();
    var totalPages = Math.ceil(totalCards / visible);

    function getVisible() {
      var w = window.innerWidth;
      if (w <= 480) return 1;
      if (w <= 768) return 1;
      if (w <= 1024) return 3;
      return 4;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      totalPages = Math.ceil(totalCards / visible);
      for (var i = 0; i < totalPages; i++) {
        var btn = document.createElement('button');
        btn.className = 'lrn-prest-dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Page ' + (i + 1));
        btn.setAttribute('data-page', i);
        btn.addEventListener('click', function () {
          goTo(parseInt(this.getAttribute('data-page')));
        });
        dotsWrap.appendChild(btn);
      }
      if (totEl) totEl.textContent = String(totalPages).padStart(2, '0');
    }

    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.lrn-prest-dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function goTo(page) {
      current = Math.max(0, Math.min(page, totalPages - 1));
      var cardWidth = cards[0].offsetWidth + 20;
      track.style.transform = 'translateX(-' + (current * visible * cardWidth) + 'px)';
      updateDots();
      if (curEl) curEl.textContent = String(current + 1).padStart(2, '0');
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= totalPages - 1;
    }

    function init() {
      visible    = getVisible();
      totalPages = Math.ceil(totalCards / visible);
      current    = 0;
      buildDots();
      goTo(0);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    // Swipe mobile
    var startX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
    }, { passive: true });

    // Drag desktop
    var isDragging = false;
    var dragStartX = 0;
    track.addEventListener('mousedown', function (e) {
      isDragging = true;
      dragStartX = e.clientX;
      track.style.cursor = 'grabbing';
    });
    document.addEventListener('mouseup', function (e) {
      if (!isDragging) return;
      isDragging = false;
      track.style.cursor = '';
      var diff = dragStartX - e.clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
    });

    // Navigation clavier
    document.addEventListener('keydown', function (e) {
      if (!track.closest('.lrn-prest-section')) return;
      if (e.key === 'ArrowLeft') goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(init, 150);
    });

    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrestationsCarousel);
  } else {
    initPrestationsCarousel();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.lrn-prest-section')) initPrestationsCarousel();
  });

})();